const getInfluencersFlowSchema = (getMessage, messages) => ({
    payoutInfo: {
        gatewayType: {
            identifier: 'gatewayType',

            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.payoutInfo.accountType')
            },
            optionLabel: {
                payPal: getMessage(messages, 'label.affiliate.form.payoutInfo.accountType.paypal'),
                bank: getMessage(messages, 'label.affiliate.form.payoutInfo.accountType.bank')
            }
        },
        foreignBank: {
            identifier: 'foreignBank',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.payoutInfo.usBank')
            },
            optionLabel: {
                yes: getMessage(messages, 'label.affiliate.form.payoutInfo.foreignBank.yes'),
                no: getMessage(messages, 'label.affiliate.form.payoutInfo.foreignBank.no')
            }
        },
        payPal: {
            identifier: 'accountEmail',
            validations: {
                isEmail: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                isEmail: getMessage(messages, 'errors.com.epicgames.validation.invalid', ['email'])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.payoutInfo.paypal')
            }
        },
        checkName: {
            identifier: 'checkName',
            validations: {
                maxLength: 64,
                validEnglishOnlyField: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [64]),
                validEnglishOnlyField: getMessage(
                    messages,
                    'errors.com.epicgames.validation.must.english',
                    [getMessage(messages, 'label.affiliate.form.payoutInfo.checkName')]
                )
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.payoutInfo.checkName')
            }
        },
        bankName: {
            identifier: 'bankName',
            require: true,
            validations: {
                maxLength: 128,
                validEnglishOnlyField: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [
                    128
                ]),
                validEnglishOnlyField: getMessage(
                    messages,
                    'errors.com.epicgames.validation.must.english',
                    [getMessage(messages, 'label.affiliate.form.payoutInfo.bankName')]
                )
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.payoutInfo.bankName')
            }
        },
        routingNo: {
            identifier: 'routingNo',
            validations: {
                maxLength: 32,
                isNumeric: true,
                validRoutingNumber: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
                isNumeric: getMessage(messages, 'errors.com.epicgames.validation.must.number'),
                validRoutingNumber: getMessage(
                    messages,
                    'errors.com.epicgames.validation.invalid',
                    ['routing number']
                )
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.payoutInfo.RoutingNum'),
                toolTip: getMessage(messages, 'ui.profile.bank.form.popover')
            }
        },
        bankAccountNo: {
            identifier: 'bankAccountNo',
            validations: {
                maxLength: 42,
                isValidBandAccountNo: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [42]),
                isValidBandAccountNo: getMessage(
                    messages,
                    'errors.com.epicgames.validation.invalid',
                    ['Bank Account number']
                )
            },
            display: {
                textBankAccountNo: getMessage(
                    messages,
                    'label.affiliate.form.payoutInfo.text_bankAccountNo'
                ),
                textIBAN: getMessage(messages, 'label.affiliate.form.payoutInfo.text_IBAN')
            }
        },
        swiftCode: {
            identifier: 'swiftCode',
            validations: {
                maxLength: 32,
                matchRegexp: /^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
                matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                    'swift code'
                ])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.payoutInfo.swiftCode')
            }
        },
        accountDetails: {
            identifier: 'additionalAccountDetail',
            validations: {
                maxLength: 1024
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [
                    1024
                ])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.payoutInfo.accountDetails')
            }
        }
    },
    signupInfo: {
        guardian: {
            firstName: {
                identifier: 'guardianFirstName',
                validations: {
                    maxLength: 32
                },
                validationMessages: {
                    isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                    maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [
                        32
                    ])
                },
                display: {
                    text: getMessage(messages, 'epic.affiliate.signup.guardian.first.name')
                }
            },
            lastName: {
                identifier: 'guardianLastName',
                validations: {
                    maxLength: 32
                },
                validationMessages: {
                    isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                    maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [
                        32
                    ])
                },
                display: {
                    text: getMessage(messages, 'epic.affiliate.signup.guardian.last.name')
                }
            },
            relationship: {
                identifier: 'guardianRelationship',
                validations: {
                    maxLength: 32
                },
                validationMessages: {
                    isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                    maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [
                        32
                    ])
                },
                display: {
                    text: getMessage(messages, 'epic.affiliate.signup.guardian.relationship')
                }
            }
        },
        language: {
            identifier: 'language',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.language')
            }
        },
        phone: {
            identifier: 'phoneNumber',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'epic.affiliate.signup.social.phone_number')
            }
        },
        url: {
            identifier: 'url',
            validations: {
                maxLength: 500
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [500])
            }
        }
    },
    taxInfo: {
        firstName: {
            identifier: 'firstName',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'epic.affiliate.signup.guardian.first.name')
            }
        },
        lastName: {
            identifier: 'lastName',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'epic.affiliate.signup.guardian.last.name')
            }
        },
        guardianFirstName: {
            identifier: 'guardianFirstName',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'epic.affiliate.form.tax.guardian.first.name')
            }
        },
        guardianLastName: {
            identifier: 'guardianLastName',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'epic.affiliate.form.tax.guardian.last.name')
            }
        },
        foreignTax: {
            identifier: 'foreignTax',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.foreignTax'),
                default: getMessage(messages, 'label.common.yes')
            }
        },
        taxType: {
            identifier: 'taxType',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.taxType')
            }
        },
        organizationId: {
            identifier: 'organizationId',
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.organization.id')
            }
        },
        email: {
            identifier: 'email',
            display: {
                text: getMessage(messages, 'ui.profile.tax.email')
            }
        },
        phoneNumber: {
            identifier: 'phoneNumber',
            validations: {
                maxLength: 17
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [17]),
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'epic.affiliate.signup.social.phone_number')
            }
        },
        paymentAmount: {
            identifier: 'paymentAmount',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.payment.amount')
            }
        },
        accountId: {
            identifier: 'accountId',
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.account.id')
            }
        },
        recordIdentityKey: {
            identifier: 'recordIdentityKey',
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.id')
            }
        },
        businessType: {
            identifier: 'businessType',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.businessType')
            }
        },
        guardianEmail: {
            identifier: 'guardianEmail',
            validations: {
                isEmail: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                isEmail: getMessage(messages, 'errors.com.epicgames.validation.invalid', ['email'])
            },
            display: {
                text: getMessage(messages, 'epic.affiliate.form.tax.guardian.email')
            }
        },
        guardianPhoneNumber: {
            identifier: 'guardianPhoneNumber',
            validations: {
                maxLength: 17
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [17])
            },
            display: {
                text: getMessage(messages, 'epic.affiliate.form.tax.guardian.phone')
            }
        },
        city: {
            identifier: 'city',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.city')
            }
        },
        zip: {
            identifier: 'zip',
            validations: {
                maxLength: 32,
                matchRegexp: /^\d{5}-\d{4}$|^\d{5}$/
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
                matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                    'zip'
                ])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.zip')
            }
        },
        country: {
            identifier: 'country',
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.Country')
            }
        },
        businessName: {
            identifier: 'businessName',
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.businessName')
            }
        },
        nameOnTaxId: {
            identifier: 'legalName',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.nameOnTaxId')
            }
        },
        address: {
            identifier: 'street',
            validations: {
                maxLength: 128
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'placeholder.localization.title')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.address')
            }
        },
        addressCity: {
            identifier: 'addressCity',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.city')
            }
        },
        addressPostCode: {
            identifier: 'addressPostCode',
            validations: {
                maxLength: 32,
                matchRegexp: /^\d{5}-\d{4}$|^\d{5}$/
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
                matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                    'zip'
                ])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.zip')
            }
        },
        addressState: {
            identifier: 'addressState',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.state')
            }
        },
        addressCountryCode: {
            identifier: 'addressCountryCode',
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.Country')
            }
        },
        addressLine1: {
            identifier: 'addressLine1',
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.addressLine1')
            }
        },
        addressLine2: {
            identifier: 'addressLine2',
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.addressLine2')
            }
        },
        SSN: {
            identifier: 'taxId',
            validations: {
                isValidSSN: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                isValidSSN: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                    'SSN number'
                ])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.ssn'),
                placeholder: getMessage(messages, 'placeholder.tax.taxId.SSN')
            }
        },
        EIN: {
            identifier: 'taxId',
            validations: {
                maxLength: 128,
                minLength: 9
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [
                    128
                ]),
                minLength: getMessage(messages, 'errors.com.epicgames.validation.min_length', [9])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.ein'),
                placeholder: getMessage(messages, 'placeholder.tax.taxId.EIN')
            }
        },
        VAT: {
            identifier: 'taxId',
            validations: {
                maxLength: 128,
                matchRegexp: /^[0-9a-zA-Z-]+$/
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [
                    128
                ]),
                matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                    'vat'
                ])
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.vat'),
                placeholder: getMessage(messages, 'placeholder.tax.taxId.VAT')
            }
        },
        TAXID: {
            identifier: 'taxId',
            validations: {
                maxLength: 128,
                matchRegexp: /^[0-9a-zA-Z-]+$/
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [
                    128
                ]),
                matchRegexp: getMessage(
                    messages,
                    'errors.com.epicgames.validation.invalid',
                    'taxId'
                )
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.id'),
                placeholder: getMessage(messages, 'label.affiliate.form.tax.id')
            }
        },
        region: {
            identifier: 'state',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'ui.profile.address.form.region'),
                textState: getMessage(messages, 'ui.profile.address.form.state')
            }
        },
        postalCode: {
            identifier: 'zip',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'ui.profile.address.form.postalCode')
            }
        },
        state: {
            identifier: 'state',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'label.affiliate.form.tax.state')
            }
        },
        w9form: {
            identifier: 'w9form',
            validations: {
                w9form: true
            },
            validationMessages: {
                w9form: getMessage(messages, 'ui.form.required')
            },
            display: {
                text: getMessage(messages, 'ui.profile.tax.form.w9form')
            }
        }
    },
    taxRecord: {
        business: {
            identifier: 'business',
            display: {
                text: getMessage(messages, 'ui.profile.tax.business')
            }
        },
        businessName: {
            identifier: 'businessName',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
            },
            display: {
                text: getMessage(messages, 'ui.profile.tax.businessName')
            }
        },
        countries: {
            identifier: 'countries',
            display: {
                text: getMessage(messages, 'ui.profile.tax.countries')
            }
        },
        organizationEmail: {
            identifier: 'organizationEmail',
            validations: {
                isEmail: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'ui.form.required'),
                isEmail: getMessage(messages, 'errors.com.epicgames.validation.invalid', ['email'])
            },
            display: {
                text: getMessage(messages, 'ui.profile.tax.organizationEmail')
            }
        }
    }
});

export default getInfluencersFlowSchema;

